import { useEffect, useState } from "react";
import { Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation } from "react-i18next";
import extraGroupsForm from "../../../formSchemas/extras.form";
import EColourPanel from "../../../interfaces/EColourPanel";
import IDynamicFormRow from '../../../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow';
import { HTTPMethods } from "../../../yoello-lib/modules/API/API";
import DynamicForm from "../../../yoello-lib/modules/dynamicForms/DynamicForms";
import { useSnackbarMessages } from "../../../yoello-lib/modules/components/snackbar/SnackbarContext";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../../reducers";
import IMenuItemBody from "../../../interfaces/IMenuItemBody";
import { useAPIV2 } from "../../../yoello-lib/modules/API2/useAPIv2";
import APIExtensions from "../../../yoello-lib/modules/API2/APIDefs";
import { ICallAPIFunction } from "../../../yoello-lib/modules/API2/types";
import { IExtraGroup } from "../../../interfaces/IExtraGroup";
import { FormPermissions } from "../../../Permissions";
import { AddItemsButton } from "./extras/ui/AddItemsButton";
import APIDefintions from "../../../yoello-lib/modules/API2/APIDefs";
import { IVAT } from "../../../interfaces/IVat";
import { IPreference } from "../preferences/PreferenceForm";
import ISubCategory from "../categories/ISubCategory";
import { menuItemAPICall, ProductType } from "./ItemsContainer";
import { ISearchableChecklistItem } from "../../../yoello-lib/modules/components/UI/Lists/SearchableChecklist/SearchableChecklistItem";
import { newProductTemplate } from "./ItemsContainer"
import { IProduct } from "../../../interfaces/IProduct";
import { TooltipContentMarkup } from "./extras/ui/TooltipContentMarkup";
import { IMultiDialogChildren } from "../../dialogRoutes/MultiDialogRoute";
import { CREATE_URL, dialogKeys, PRODUCTS_EXTRAS } from "../../../const/URL.const";
import { useDialogSetup } from "../../dialogRoutes/useDialogSetup";
import { useChangedDialog } from "../../../hooks/useChangedDialog";
import { FilterOptionsType } from "../../../yoello-lib/modules/components/UI/Lists/AdvancedChecklist/state/AdvancedChecklist.actions";
import useCheckPermissions from "../../../hooks/useCheckPermissions";
import { PERMISSIONS } from "../../../const/permissions.const";
import { FormLoadingWrapper } from "../../util/FormLoadingWrapper";
import ListLoading from "../../util/Loading";
export interface IExtrasDialogForm extends IMultiDialogChildren {
  formData: any;
  venueId: string;
  isNewItem: boolean;
  callAPI: ICallAPIFunction<IExtraGroup>;
  menuItems: IMenuItemBody[];
  subcategories: ISubCategory[];
  vat: IVAT[];
  isLoading: boolean;
  extraGroups: IExtraGroup[];
  preferences: IPreference[];
  tags: IItemTags[];
  menuItemAPICall: menuItemAPICall;
  id: string;
}

/**Extras dialog form, for handling updating/adding/removing extras from groups and the group */
export function ExtrasDialogForm(props: IExtrasDialogForm) {
  const {
    venueId,
    onClose,
    isNewItem,
    callAPI,
    menuItems,
    id,
    onDialogClose
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [isReorderd, setIsReorderd] = useState(false);
  const [formRows, setFormRows] = useState<IDynamicFormRow[] | undefined>(undefined);

  const venueData = useSelector((state: IReduxAppState) => state.venue[venueId]?.venueData);
  const isSquare = venueData?.payment_processor === 'SQUARE';
  const [selectedMenuItems, setSelectedMenuItems] = useState<IMenuItemBody[]>();
  const { hasFormChanged } = useChangedDialog();

  const { hasPermission, onFailedInteraction} = useCheckPermissions(PERMISSIONS.MENU_MANAGEMENT);

  const { t } = useTranslation();
  const snackbarContext = useSnackbarMessages()!;
  /**Calls used for the relationships of the extra groups */
  const { callAPI: extraRelationshipAPI } = useAPIV2<IMenuItemBody[]>(APIExtensions.extraGroups, { onMountDisabled: true });

  const { goToNextStep, goToPrevStep, setProps, getProps, isLoading: isSettingUp, formData, setFormData, closeAllModals } = useDialogSetup(props, callAPI);
  const [formState, setFormState] = useState<any>();

  const isEposNow = useSelector((state: IReduxAppState) => state.isEposNow);
  const subscription = useSelector((state: IReduxAppState) => state.subscription);
  const { callAPI: searchExtraItems } = useAPIV2(
    APIDefintions.extraGroups,
    {
      onMountDisabled: true,
      doNotCacheValue: true,
      selectorKeyParams: { venue_id: venueId },
      dispatcherParams: [venueId],
    },
  );
  const fieldList: any = [
    {
      key: "",
      modifier: (enabled: boolean, cardData: IMenuItemBody) => {
        return <div>
          <p>{cardData.name_public}</p>
          <p>{cardData.name_internal}</p>
        </div>
      }
    },
    {
      key: "",
      modifier: (enabled: boolean, cardData: IMenuItemBody) => {
        return !isEposNow ? <Button onClick={() => onDeleteSelectedItem(cardData.id ?? cardData.name_public)}>
          <CloseIcon />
        </Button> : null
      }
    }
  ]
  useEffect(() => {
    if (!formData && !isNewItem) return;
    //geting checked items without submiting form
    let selectedItems: any = getProps(props.dialogKey, "selectedItems");
    if (!selectedItems && !isNewItem) {
      searchExtraItems(HTTPMethods.GET, {
        query: `${formData?.id ?? id}/menu_items`,
        params: { include_disabled: true, sort_field: 'sort_position', sort_direction: 'asc' }
      }).then((data) => {
        const selectedItems = data.data as IMenuItemBody[];
        if (Array.isArray(selectedItems)) {
          setSelectedMenuItems(selectedItems);
          const ids = selectedItems.map(item => item.id);
          setProps(props.dialogKey, "selectedItems", selectedItems);
          setProps(props.dialogKey, "oldSelectedItems", ids);
          setProps(props.dialogKey, "itemPosition", ids);
          setFormState({
            ...formData,
            selectedItems: ids
          })
        }
      });
    }
    else {
      setSelectedMenuItems(selectedItems ?? []);
      if (isNewItem) {
        setFormState({
          ...formData,
          selectedItems: selectedItems ?? []
        })
      } else {
        const oldItems = getProps(props.dialogKey, "oldSelectedItems");
        setFormState({
          ...formData,
          selectedItems: oldItems ?? selectedItems
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNewItem, formData]);
  useEffect(() => {
    const selectedItems: IMenuItemBody[] | undefined = getProps(props.dialogKey, "selectedItems");
    const itemPosition: string[] | undefined = getProps(props.dialogKey, "itemPosition");
    /**re-sorts the list of items when travelling between dialogs  */
    if (Array.isArray(selectedItems) && Array.isArray(itemPosition)) {
      updateSelectedItemsPosition(itemPosition, selectedItems)
    }
    //eslint-disable-next-line
  }, [])

  const filterOptions: FilterOptionsType[] = [{
    label: t("misc.subcategory"),
    optionLabelKey: "subcategory_name",
    optionFilterKey: "id",
    itemFilterKey: "subcategory_id",
    filterOptionsList: props.subcategories || [],
  }];
  useEffect(() => {
    const rows: IDynamicFormRow[] =
      [
        ...extraGroupsForm(t, props, isEposNow, isNewItem, closeAllModals,onFailedInteraction),
        {
          Component: AddItemsButton,
          label: t("menu.extras.AddItemsToExtraTitle"),
          keyName: "selectedItems",
          disabled: !hasPermission,
          formProps: {
            secondLabel: t("menu.extras.ClickToAddText"),
            formData: formData,
            isNewItem: isNewItem,
            dialogTitle: !isNewItem ? t("menu.extras.AddItemsTitle", { name: formData?.name_public ?? "" }) : t("menu.extras.AddItemsTitleToExtra"),
            itemsList: selectedMenuItems,
            setPreviousData: true,
            useReOrderingList: true,
            onDeleteSelectedItem: onDeleteSelectedItem,
            selectedItemsText: t("menu.extras.ItemsInGroup"),
            isFormDialog: false,
            onSortItems: updateSelectedItemsPosition,
            fieldList: fieldList,
            dataComponentName: "EXTRA_GROUP_LIST",
            goToNextStep,
            goToPrevStep,
            setProps,
            getProps,
            id,
            prevModal: props.dialogKey,
            parentPath: PRODUCTS_EXTRAS,
            formDataKey: "formData",
            dialogProps: {
              items: menuItems,
              isLoading: isLoading,
              onClose,
              onSubmit: onSubmit,
              onCreate: (selectedItems: ISearchableChecklistItem[]) => goToProductModal(newProductTemplate, selectedItems, true),
              submitText: t("menu.extras.confirm"),
              filterOptions,
              toolTipContent: <TooltipContentMarkup />,
              isSquare: isSquare,
              hasMainItemTag: true,
              disableItemTypeSelection: ProductType.MainItem,
              subLabelKey: "name_internal",
              hasSubmitCancelButtons: true,
              hasToolbar: true,
              showTooltip: true,
              hasCreateButton: true,
              isVirtualizeList: true,
              persistSelectedFilters: true,
              parentModalKey: props.dialogKey
            }
          },
        }
      ];
    setFormRows(rows);
    // eslint-disable-next-line
  }, [formData, selectedMenuItems]);

  function onDeleteSelectedItem(id: string) {
    setSelectedMenuItems(selectedMenuItems ? selectedMenuItems.filter((item: any) => item.id !== id) : []);
  }
  async function onSubmit(selectedItems: ISearchableChecklistItem[], menuItems?: IMenuItemBody) {
    let selectedMenuItems: IMenuItemBody[] = [];
    if (menuItems) {
      selectedItems.forEach((item: ISearchableChecklistItem) => {
        menuItems.forEach((menuItem: IMenuItemBody) => {
          if (item.id === menuItem.id) {
            selectedMenuItems.push(menuItem)
          }
        })
      })
    }
    setProps(props.dialogKey, "selectedItems", selectedMenuItems);
  }
 
  function goToProductModal(product: IProduct | IMenuItemBody, selectedItems: ISearchableChecklistItem[], isNew?: boolean) {
    const item = product.details ? product.details : product
    goToNextStep("items", {
      ComponentProps: {
        subcategories: props.subcategories,
        item,
        vat: props.vat,
        venueId: venueId,
        tags: props.tags,
        removeAddToExtraGroup: true,
        onClose: () => goToPrevStep(dialogKeys.ASSIGNITEM),

      },
      isFormDialog: true,
      dialogTitle: t("forms.modify.title"),
    }, `${PRODUCTS_EXTRAS}/items/${isNew ? CREATE_URL : item?.id}`,
      dialogKeys.ASSIGNITEM)
  }
  async function submitForm(submittedFormData: any) {
    //filters should be remove after form submiting
    const selectedFilterIDs: string[] = JSON.parse(window.localStorage.getItem("selectedFiltersIDs") ?? "[]");
    if (selectedFilterIDs.length > 0) {
      window.localStorage.setItem("selectedFiltersIDs", '');
    }
    const data = { ...formData, ...submittedFormData };
    setProps(props.dialogKey, "selectedItems", selectedMenuItems);
    setProps(props.dialogKey, "formData", { ...data, selectedItems: selectedMenuItems });
    setFormData({ ...data, selectedItems: selectedMenuItems });

    const extras_list = selectedMenuItems ? selectedMenuItems.map(item => { return { "id": item.id } }) : [];

    setSelectedMenuItems(data.selectedItems);
    setIsLoading(true);
    if (venueId) {
      const data = { ...submittedFormData, venue_id: venueId };
      const quantity_min = parseInt(data.quantity_min);
      const quantity_max = parseInt(data.quantity_max);
      if (!isEposNow) {
        if (quantity_min > quantity_max) {
          snackbarContext.sendSnackbarMessage(t('snackbar.minMoreThanMax', { quantity_min, quantity_max }), "error");
          setIsLoading(false);
          return;
        }
        if (quantity_min > 0 && extras_list.length < 1) {
          snackbarContext.sendSnackbarMessage(t('snackbar.extrasMinItemsError', { quantity_min, quantity_max }), "error");
          setIsLoading(false);
          return;
        }
      }

      const extraGroupData =
      {
        ...data,
        quantity_min,
        quantity_max,
        extras_list: undefined,
        enabled: true
      };
      let groupID = ``;
      if (isNewItem) {
        await callAPI(HTTPMethods.POST, { body: extraGroupData, doNotCacheValue: true }).then((result: any) => groupID = result.data.id);
        if (!groupID) { throw Error(`newExtraGroup did not get set`); }
      }
      else {
        groupID = formData.id || groupID;
        await callAPI(HTTPMethods.PUT, { body: extraGroupData, query: groupID, doNotCacheValue: true });
      }
      const query = `${groupID}/menu_items`;

      await extraRelationshipAPI(HTTPMethods.DELETE, { query });
      if (extras_list.length > 0) {
        await extraRelationshipAPI(HTTPMethods.PUT, { query, body: selectedMenuItems });
      }
    }
    if (onDialogClose) {
      onDialogClose();
    } else {
      onClose();
    }
    setIsLoading(false);
    if (isReorderd) {
      setIsLoading(false);
    }
    if (isNewItem) { snackbarContext.sendSnackbarMessage(t("menu.extras.addExtras"), "success"); }
    else { snackbarContext.sendSnackbarMessage(t("menu.extras.updateExtras"), "success"); }
  }
  function updateSelectedItemsPosition(itemPosition: string[], selectedItems?: IMenuItemBody[]) {
    let sortedItems = [];
    //@ts-ignore
    const menuItems: IMenuItemBody[] = selectedItems ?? [...selectedMenuItems];
    const newPosition = Array.isArray(itemPosition) ? itemPosition : [];

    setProps(props.dialogKey, "itemPosition", newPosition);
    for (const id of newPosition) {
      const itemListIndex = menuItems.findIndex((item) => item.id === id);
      if (itemListIndex > -1) {
        sortedItems.push(menuItems[itemListIndex]);
        menuItems.splice(itemListIndex, 1);
      }
    }
    if (menuItems.length > 0) {
      sortedItems = [...sortedItems, ...menuItems]
    }
    setSelectedMenuItems(sortedItems);
    if (isEposNow) {
      setIsReorderd(true)
    }
  }

  return !formRows || !formState || isLoading || isSettingUp ?
    <FormLoadingWrapper><ListLoading/></FormLoadingWrapper> :
    <DynamicForm formData={formState} formKeyName="mysettings"
      formRows={formRows!} onHandleSubmit={submitForm}
      disabledFields={FormPermissions["extrasdialog"]}
      subscriptionKey={subscription}
      isDialog={true}
      hasDataChanged={hasFormChanged}
      disableAll={!hasPermission}
      disableAllInteraction={onFailedInteraction}
      formButtons={{
        leftButton: {
          type: "button", label: t('forms.buttons.cancel'), color: EColourPanel.DEFAULT, fullWidth: false,
          onClick: onClose
        },
        rightButton: {
          type: "submit", disabled: (isEposNow && !isReorderd) || !hasPermission || isLoading, label: t('forms.buttons.submitExtrasupdates'), color: EColourPanel.PRIMARY, fullWidth: false
        }
      }}
    />;
}
